//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'

//#endregion

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { ResponseValidateInfoModel, FieldNameValueModel, FormValuesModel } from '../../api/api.models'

import { CommonCreateEdit } from '../../common/common.create-edit'
import { EventsNames } from '../../../helpers/events-names'
import { GridOptions, GridTypes } from '../../common/grid/grid.controller'
import { i18n } from '../../common/i18n/common.i18n'
import { LoggerService } from '../../common/common.module'

import { ConvertHelper } from '../../../helpers/convert-helper'
import { CommonHelper, DataType, ValidationStatus } from '../../../helpers/common-helper'
import { IUserSession } from '../../../helpers/user-session'
import { Md5 } from '../../../helpers/md5-helper'
import { PopupType } from './../../../helpers/popup-manager'

import { Enums } from '../../../models/common/enums'
import { IssueHelper } from '../issues.helper'


interface IssueCreateIssuesTasksScope extends ng.IScope {
    //Popup props
    popupOptions: DevExpress.ui.dxPopupOptions
    popupVisible: boolean
    title: string
    popupType: any

    //Form props
    dictionary: any
    panels: any
    tabItems: any[]
    onPopoverValueIdSelected(valueId: number, datatypeId: number): void
    isEditMode: boolean

    //Grid props
    gridOptions: GridOptions
    gridData: any
    gridColumns: any
    grid: DevExpress.ui.dxDataGrid

    //Buttons props
    startButtonOptions: DevExpress.ui.dxButtonOptions
    stopButtonOptions: DevExpress.ui.dxButtonOptions
    finishButtonOptions: DevExpress.ui.dxButtonOptions
    isStarted: boolean
    finishSignal: boolean
    savingProgressOptions: DevExpress.ui.dxProgressBarOptions
    uploadedPercent: number
    actualSavedLocation: number

    bulkEditWarningId: any
    saveBulkEntities()
}

export class IssueCreateIssuesTasksDirectiveController extends CommonCreateEdit {
    referenceTableCount: number = 0
    referenceTypeFieldName: string = 'referenceTypeField'
    createGridPromise = $.Deferred<void>()
    gridId: any
    formModels: any[] = []

    statesFormInstance: ng.IDeferred<DevExpress.ui.dxSelectBox>
    distributorFormInstance: DevExpress.ui.dxSelectBox
    previousRequestMd5: string

    constructor(protected $scope: IssueCreateIssuesTasksScope, $q: ng.IQService, $element: JQuery, $timeout: ng.ITimeoutService, protected api: Api, logger: LoggerService,
        protected localDictionary: LocalDictionaryFactory, protected userSession: IUserSession) {
        super($scope, api, localDictionary, $q, $timeout, userSession)

        $scope.popupVisible = false
        $scope.title = ""
        $scope.uploadedPercent = 0
        $scope.isStarted = false
        $scope.actualSavedLocation = 0
        $scope.finishSignal = false
        $scope.isEditMode = false

        $scope.bulkEditWarningId = new Date().getTime() + 'bulkWarning'

        $scope.popupOptions = {
            bindingOptions: {
                visible: 'popupVisible',
                title: 'title'
            },
            fullScreen: true,
            showTitle: true,
            closeOnOutsideClick: true,
            onHiding: this.closePopup,
            onShowing: () => {
                this.previousRequestMd5 = ""
            }
        }

        $scope.startButtonOptions = {
            text: i18n('Popup', 'Start'),
            bindingOptions: {
                disabled: 'isStarted'
            },
            onClick: this.saveEntitiesResetMd5
            }

        $scope.stopButtonOptions = {
            text: i18n('Popup', 'Stop'),
            bindingOptions: {
                disabled: '!isStarted'
            },
            onClick: this.stopSaving
        }

        $scope.finishButtonOptions = {
            text: i18n('Popup', 'Finish'),
            bindingOptions: {
                disabled: 'isStarted'
            },
            onClick: this.finishSaving
        }

        $scope.savingProgressOptions = {
            visible: true,
            statusFormat: (ratio, value) => {
                return i18n('Popup', 'Progress') + ': ' + Math.round(ratio * 100) + '%'
            },
            bindingOptions: {
                value: 'uploadedPercent'
            },
            value: 0,
            min: 0,
            max: 100
        }

        $scope.onPopoverValueIdSelected = (valueId: number, datatypeId: number = null) => {
            this.onPopoverValueIdSelected(valueId, datatypeId)
        }

        var loadColumns = () => {
            switch ($scope.popupType) {
                case PopupType.ISSUE_POPUP:
                    return $q.all([localDictionary.getIssueEditFields(), localDictionary.getIssueRequiredFields()]).then(([columnsEdit, required]) => {
                        return {
                            name: i18n("Common", "Basics"),
                            type: "form",
                            columns: columnsEdit,
                            required: required
                        }
                    }).then(dict => {
                        $scope.dictionary = [dict]
                    })

                case PopupType.TASK_POPUP:
                    return $q.all([localDictionary.getTaskEditFields(), localDictionary.getTaskRequiredFields()]).then(([columnsEdit, required]) => {
                        return {
                            name: i18n("Common", "Basics"),
                            type: "form",
                            columns: columnsEdit,
                            required: required
                        }
                    }).then(dict => {
                        $scope.dictionary = [dict]
                    })
            }
        }

        $scope.saveBulkEntities = () => {
            this.$scope.isStarted = true
            $timeout(() => {
                if (this.formModels != null) {
                    this.formModels.forEach(item => {
                        this.saveLocationsTasks(item)
                    })
                }
            })
        
        }

        $scope.$on(IssueHelper.ISSUES_OPEN_CREATE_ISSUE_TASK, (event: ng.IAngularEvent, ...args: any[]) => {
            $scope.popupVisible = true
            $scope.finishSignal = false
            $scope.title = "Create Issues Tasks"
            $scope.popupType = PopupType.ISSUE_POPUP

            if (args && args[0]) {
                $scope.popupType = args[0]
            }

            switch ($scope.popupType) {
                case PopupType.ISSUE_POPUP:
                    $scope.title = i18n('Common', 'MassIssueCreate')
                    break

                case PopupType.TASK_POPUP:
                    $scope.title = i18n('Common', 'MassTaskCreate')
                    break
            }

            //FORM
            loadColumns().then(() => {
                this.updateTabs($scope, $scope.dictionary)
                $scope.panels = []

                $scope.dictionary.forEach(section => {
                    switch ($scope.popupType) {
                        case PopupType.ISSUE_POPUP:
                            section.columns = section.columns.filter(item => { return item.id != DataType.HELPER_ID_LOCATION })
                            break

                        case PopupType.TASK_POPUP:
                            section.columns = section.columns.filter(item => { return item.id != DataType.HELPER_ID_LOCATION && item.id != DataType.HELPER_ID_DISTRIBUTOR })
                            break
                    }

                    switch (section.type) {
                        default:
                        case "form":
                            this.createForm(section, {}, null)
                            break
                    }
                    $scope.panels.push(section)
                })
            })

            //GRID
            if (args && args[1]) {
                $scope.gridData = args[1]
            }

            if (args && args[2]) {
                $scope.gridColumns = args[2]
            }

            this.createGrid()
        })
    }

    saveEntitiesResetMd5 = () => {
        this.previousRequestMd5 = "";
        this.submit();
    }

    saveEntities = () => {
        this.submit();
    }

    prepareToValidation() {
        var deferred = this.$q.defer()
        var sections: any[] = this.$scope.panels
        var formModels: any[] = []
        var actualLocation: number = 0

        this.$scope.gridData.forEach(gridData => {
            var isValid = true

            if (isValid) {
                var unique = {}
                var fields: FieldNameValueModel[] = []

                if (actualLocation) {
                    actualLocation = 0
                }
                var item = this.$scope.gridData[actualLocation]

                var promisedValues = []
                sections.forEach(section => {
                    var id = parseInt(item.id)
                    if (!unique[id]) {
                        angular.forEach(section.formData, (value, key) => {
                            section.columns.forEach(column => {
                                if (column.id == key) {
                                    section.columns.forEach(gColumn => {
                                        if (column.caption == gColumn.caption) {
                                            if (gColumn.referenceValue) {
                                                var nameValue = new FieldNameValueModel()
                                                nameValue.idDataType = column.id
                                                nameValue.value = gColumn.referenceValue
                                                fields.push(nameValue)
                                            } else if (column.referenceTypeId != null && column.id != CommonHelper.meterColumnId) {
                                                promisedValues.push({ promised: this.localDictionary.getReferenceTable(column.referenceTypeId, column.id), columnId: column.id, dataField: item[gColumn.dataField] })
                                            } else {
                                                var nameValue = new FieldNameValueModel()
                                                nameValue.idDataType = column.id
                                                nameValue.value = item[gColumn.dataField]
                                                fields.push(nameValue)
                                            }
                                        }
                                    })
                                }
                            })
                        })
                        unique[id] = true
                    }
                })

                var formModel = new FormValuesModel()
                formModel.id = gridData.id
                formModel.fields = fields
                formModels[actualLocation] = formModel

            }
            actualLocation++
        })

        return deferred.promise
    }

    stopSaving = () => {
        this.$scope.isStarted = false
    }

    finishSaving = () => {
        this.$scope.finishSignal = true
        this.$scope.popupVisible = false
    }

    closePopup = () => {
        this.$scope.gridColumns = []
        this.$scope.gridData = []
        this.$scope.isStarted = false
        this.$scope.actualSavedLocation = 0
        this.$scope.uploadedPercent = 0
        this.formModels = []
    }

    validateTask(formModels: FormValuesModel[], iterraction: number = 0, validateInfo: ResponseValidateInfoModel = null, deferred = null) {
        if (!deferred)
            deferred = this.$q.defer()
        const pageSize: number = window['config'].LOCATION_VALIDATION_PAGE_SIZE//czy ma byc taki sam rozmiar paczki
        const start: number = iterraction * pageSize
        const end: number = start + pageSize
        const part: FormValuesModel[] = formModels.length > pageSize ? formModels.slice(start, end) : formModels

        part.forEach((part: FormValuesModel, index: number) => {
            part.fields.forEach((field: FieldNameValueModel) => {
                if (field.idDataType == Enums.DataType.HELPER_ID_LOCATION) {
                    const helperIdIssue = this.$scope.gridData[index].id
                    this.assignCustomFieldsToForm(field.value, part, helperIdIssue)
                }
            })
        })
      
        if (window['config'].USE_REST_API) {
            this.api.task.validateTasks(part).then(info => {
                if (!info.hasErrorCode) {
                    if (!validateInfo) {
                        validateInfo = info
                    } else {
                        if (info.result)
                            info.result.forEach(item => {
                                validateInfo.result.push(item)
                            })
                    }
                    if (formModels.length > end)
                        this.validateTask(formModels, ++iterraction, validateInfo, deferred)
                    else
                        deferred.resolve(validateInfo)
                } else {
                    deferred.reject()
                }
            }).catch(reason => {
                return deferred.reject()
            })
        }
        return deferred.promise
    }

    terminateSaving() {
        this.$scope.isStarted = false
        this.$scope.actualSavedLocation = 0
        this.calculateUpload()
        this.restoreGrid()
        this.$scope.finishSignal = false
    }

    restoreGrid() {
        for (var i = 0; i < this.$scope.gridData.length; i++) {
            this.$scope.gridData[i].success = null
            this.$scope.gridData[i].error = null
        }

        this.$scope.gridOptions.dataSource = new DataSource(this.$scope.gridData)
        this.$scope.grid.repaint()
        this.$scope.grid.collapseAll(-1)
    }

    submit() {
        var sections: any[] = this.$scope.panels

        if (this.$scope.gridData.length == this.$scope.actualSavedLocation) {
            this.terminateSaving()
        }

        var isValid = this.isSectionsValid(sections)

        if (isValid) {
            this.$scope.isStarted = true
            var unique = {}
            var fields: FieldNameValueModel[] = []
            sections.forEach(section => {
                if (section.form) {
                    Object.keys(section.formData).forEach(property => {
                        var id = parseInt(property)
                        if (!unique[id]) {
                            var nameValue = new FieldNameValueModel()
                            nameValue.idDataType = id
                            nameValue.value = section.formData[property]
                            fields.push(nameValue)
                            unique[id] = true
                        }
                    })
                }
                if (section.grid) {
                    section.grid.option("dataSource").items().forEach(item => {
                        var id = parseInt(item.index)
                        if (!unique[id]) {
                            var nameValue = new FieldNameValueModel()
                            nameValue.idDataType = id
                            nameValue.value = item.value
                            fields.push(nameValue)
                            unique[id] = true
                        }
                    })
                }
            })

            var formModel = new FormValuesModel()
            formModel.id = null
            formModel.fields = fields

            if (this.previousRequestMd5 !== Md5.init(formModel)) {
                this.previousRequestMd5 = Md5.init(formModel)
                switch (this.$scope.popupType) {
                    case PopupType.ISSUE_POPUP:
                        this.saveLocationsIssues(formModel)
                        break
                    case PopupType.TASK_POPUP:
                        let gridDataSize = this.$scope.gridData.length
                        let iterraction = 0

                        for (let i = 0; i != gridDataSize; i++) {
                            this.formModels[i] = angular.copy(formModel)
                        }

                        this.$scope.gridData.forEach(item => {
                            this.formModels[iterraction].fields.push(<FieldNameValueModel>{ idDataType: DataType.HELPER_ID_LOCATION, value: item.idLocation })
                            iterraction++
                        })

                        this.validateTask(this.formModels).then((validateInfo: ResponseValidateInfoModel) => {
                                if (!validateInfo.hasErrorCode) {
                                    var correctCount: number = 0
                                    var errorCount: number = 0
                                    var warningCount: number = 0

                                    if (validateInfo.result && validateInfo.result.length > 0) {
                                        validateInfo.result.forEach((info, index) => {
                                            var needExpandRow: boolean = false
                                            if (info.status == ValidationStatus.Incorrect || info.status == ValidationStatus.Unknown) {
                                                errorCount++
                                                this.$scope.gridData[index].error = info.message || i18n('Common', 'UnexpectedError')
                                                this.$scope.gridOptions.dataSource = new DataSource(this.$scope.gridData)
                                                //this.$scope.bulkGrid.refresh()

                                                needExpandRow = true
                                                this.$scope.isStarted = false
                                            }
                                            if (info.status == ValidationStatus.Warning) {
                                                warningCount++
                                                this.$scope.gridData[index].warning = info.message || i18n('Common', 'UnexpectedError')
                                                this.$scope.gridOptions.dataSource = new DataSource(this.$scope.gridData)
                                                //this.$scope.bulkGrid.refresh()

                                                needExpandRow = true
                                                this.$scope.isStarted = false
                                            }
                                            if (needExpandRow) {
                                                this.$scope.grid.expandRow(this.$scope.gridData[index].id)
                                            }
                                        })

                                        if (!errorCount) {
                                            if (!warningCount) {
                                                this.saveLocationsTasks(formModel)
                                                this.saveEntities()
                                            } else {
                                                var errorMsg = ''
                                                validateInfo.result.forEach(item => {
                                                    if (item.status == ValidationStatus.Warning) {
                                                        item.message.forEach(msg => {
                                                            errorMsg += (msg || i18n('Common', 'UnexpectedError'))
                                                        })
                                                        errorMsg += '</br>'
                                                    }
                                                })
                                                this.$scope.$broadcast(EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.bulkEditWarningId, errorMsg)
                                            }
                                        } else {
                                            CommonHelper.openInfoPopup(i18n('Common', 'WatchErrors'), 'error', 5000)
                                        }
                                    }
                                    else {
                                        this.$scope.gridData = this.$scope.gridData.map(data => {
                                            data.error = i18n('Common', 'UnexpectedError')
                                            return data
                                        })
                                        this.$scope.gridOptions.dataSource = new DataSource(this.$scope.gridData)
                                        this.$scope.grid.expandAll(-1)
                                    }
                                    this.$scope.grid.refresh()
                                }
                        })
                        this.saveEntities()
                        break
                }
            }
        }
        else {
            CommonHelper.openInfoPopup(i18n('Common', 'IncorrectData'), 'error', 5000)
            angular.element('.dx-invalid').css('height', '36px')
        }
    }

    saveLocationsIssues(formModel: FormValuesModel) {
        if (!this.$scope.finishSignal) {
            if (this.$scope.isStarted) {
                if (this.$scope.gridData.length > this.$scope.actualSavedLocation) {
                    var locationId = this.$scope.gridData[this.$scope.actualSavedLocation].id
                    this.setLocationToFields(formModel.fields, locationId)
                    this.saveSingleLocationIssue(locationId, formModel)
                }
                else {
                    this.$scope.isStarted = false
                    this.previousRequestMd5 = ''
                }
            }
        }
        else {
            this.terminateSaving()
            this.previousRequestMd5 = ''
        }
    }
    
    saveSingleLocationIssue(locationId: number, form: FormValuesModel) {
        return this.api.issue.createMassIssue(form).then(issue => {
            if (!issue) {
                this.$scope.gridData[this.$scope.actualSavedLocation].error = i18n("Common", "WebServiceException")
                this.$scope.gridOptions.dataSource = new DataSource(this.$scope.gridData)
                this.$scope.grid.repaint()
                this.$scope.grid.expandRow(this.$scope.gridData[this.$scope.actualSavedLocation])
            }
            else {
                if (issue.hasErrorCode && issue.hasErrorCode > 0) {
                    this.$scope.gridData[this.$scope.actualSavedLocation].error = CommonHelper.getErrorMessage(issue.hasErrorCode, issue.errorMessage)
                    this.$scope.gridOptions.dataSource = new DataSource(this.$scope.gridData)
                    this.$scope.grid.repaint()
                    this.$scope.grid.expandRow(this.$scope.gridData[this.$scope.actualSavedLocation])
                }
                else {
                    this.$scope.gridData[this.$scope.actualSavedLocation].success = "success"
                    this.$scope.gridOptions.dataSource = new DataSource(this.$scope.gridData)
                    this.$scope.grid.repaint()
                }
            }
            this.$scope.actualSavedLocation++
            this.calculateUpload()
            this.saveLocationsIssues(form)
        }).catch(err => {
            console.log(err)
        })
    }

    saveLocationsTasks(formModel: FormValuesModel) {
        if (!this.$scope.finishSignal) {
            if (this.$scope.isStarted) {
                if (this.$scope.gridData.length > this.$scope.actualSavedLocation) {
                    var locationId = this.$scope.gridData[this.$scope.actualSavedLocation].idLocation
                    this.setLocationToFields(formModel.fields, locationId)
                    const helperIdIssue: number = this.$scope.gridData[this.$scope.actualSavedLocation].id
                    this.saveSingleLocationTask(locationId, formModel, helperIdIssue)
                }
                else {
                    this.$scope.isStarted = false
                    this.previousRequestMd5 = ''
                }
            }
        }
        else {
            this.terminateSaving()
            this.previousRequestMd5 = ''
        }
    }

    assignCustomFieldsToForm(locationId: number, form: FormValuesModel, helperIdIssue: number): FormValuesModel {
        const formFields: FieldNameValueModel[] = form.fields.filter((field: FieldNameValueModel) => field.idDataType === DataType.HELPER_CREATION_DATE || field.idDataType === DataType.HELPER_ID_ISSUE || field.idDataType === DataType.HELPER_ID_LOCATION)
        const creationDateField: FieldNameValueModel = _.find(formFields, (field: FieldNameValueModel) =>
            field.idDataType === DataType.HELPER_CREATION_DATE
        )
        if (creationDateField != null) {
            creationDateField.value = ConvertHelper.dateToString(new Date())
        } else {
            form.fields.push(<FieldNameValueModel>{ idDataType: DataType.HELPER_CREATION_DATE, value: ConvertHelper.dateToString(new Date()) })
        }

        const helperIdIssuefield = _.find(formFields, (field: FieldNameValueModel) =>
            field.idDataType === DataType.HELPER_ID_ISSUE
        )
        if (helperIdIssuefield != null) {
            helperIdIssuefield.value = helperIdIssue
        } else {
            form.fields.push(<FieldNameValueModel>{ idDataType: DataType.HELPER_ID_ISSUE, value: helperIdIssue })
        }

        const helperIdLocationfield = _.find(formFields, (field: FieldNameValueModel) =>
            field.idDataType === DataType.HELPER_ID_LOCATION
        )
        if (helperIdLocationfield) {
            helperIdLocationfield.value = locationId
        } else {
            form.fields.push(<FieldNameValueModel>{ idDataType: DataType.HELPER_ID_LOCATION, value: locationId })
        }
        return form
    }

    saveSingleLocationTask(locationId: number, form: FormValuesModel, helperIdIssue: number) {
        if (form != null && form.fields != null && form.fields.length > 0 && locationId != null && helperIdIssue != null) {
            form = this.assignCustomFieldsToForm(locationId, form, helperIdIssue)
       }

        return this.api.task.createMassTask(form).then(task => {
            if (!task) {
                this.$scope.gridData[this.$scope.actualSavedLocation].error = i18n("Common", "WebServiceException")
                this.$scope.gridOptions.dataSource = new DataSource(this.$scope.gridData)
                this.$scope.grid.repaint()
                this.$scope.grid.expandRow(this.$scope.gridData[this.$scope.actualSavedLocation])
            }
            else {
                if (task.hasErrorCode && task.hasErrorCode > 0) {

                    if (this.$scope.gridData[this.$scope.actualSavedLocation].error == null) {
                        this.$scope.gridData[this.$scope.actualSavedLocation].error = CommonHelper.getErrorMessage(task.hasErrorCode, task.errorMessage)
                    }
                    this.$scope.gridOptions.dataSource = new DataSource(this.$scope.gridData)
                    this.$scope.grid.repaint()
                    this.$scope.grid.expandRow(this.$scope.gridData[this.$scope.actualSavedLocation])

                }
                else {
                    this.$scope.gridData[this.$scope.actualSavedLocation].success = "success"
                    this.$scope.gridOptions.dataSource = new DataSource(this.$scope.gridData)
                    this.$scope.grid.repaint()
                }
            }
            this.$scope.actualSavedLocation++
            this.calculateUpload()
            this.saveLocationsTasks(form)
        }).catch(err => {
            console.log(err)
            })
    }

    calculateUpload() {
        this.$scope.uploadedPercent = (this.$scope.actualSavedLocation / this.$scope.gridData.length) * 100
    }

    setLocationToFields(fields: any[], locationId: any) {
        for (var i = 0; i < fields.length; i++) {
            if (fields[i].idDataType == CommonHelper.locationColumnId) {
                fields[i].value = locationId
            }
        }
    }

    updateTabs($scope: IssueCreateIssuesTasksScope, sections: any[]) {
        $scope.tabItems = sections.map(section => {
            return {
                template: (itemData, itemIndex, itemElement) => {
                    this.$scope['showSectionError' + itemIndex] = false
                    return section.name + '<ng-md-icon ng-show="showSectionError' + itemIndex + '" icon="' + window['config']['ICONS']['REQUIRED_TAB'] + '" style="fill: #ea4444; vertical-align: middle;" size="20"></ng-md-icon>'
                }
            }
        })
    }

    createForm(section, data, idReferenceType) {
        section.formData = {}
        section.items = []
        section.onFieldChanged = (e) => {
            var dataField = e.element.get(0).attributes['table-id'].nodeValue
            if (dataField) {
                var number = parseFloat(e.selectedItem.id)
                if (!isNaN(number))
                    section.formData[dataField] = number
                else
                    section.formData[dataField] = e.selectedItem.id

                this.trackChanges(section, dataField, e.selectedItem.id)
            } else {
                var value = (e.selectedItem.id) ? e.selectedItem.id : ''
                section.formData[dataField] = value
                this.trackChanges(section, dataField, value)
            }
        }
         
        section.onDateFieldChanged = (e) => {
            this.trackChanges(section, e.element.get(0).attributes['table-id'].nodeValue, e.value)
        }

        section.initializedHandler = (e) => {
            if (e.element.get(0).attributes['table-id'].nodeValue == CommonHelper.distributorColumnId) {
                this.distributorFormInstance = e.component
            }

            if (e.element.get(0).attributes['table-id'].nodeValue == CommonHelper.issueStatusColumnId || e.element.get(0).attributes['table-id'].nodeValue == CommonHelper.taskStatusColumnId) {
                this.statesFormInstance.resolve(e.component)
            }
        }

        section.options = <DevExpress.ui.dxFormOptions>{
            onFieldDataChanged: (e: any) => {
                this.trackChanges(section, e.dataField, e.value)
            },
            requiredMark: '*',
            showRequiredMark: true,
            labelLocation: 'top',
            colCount: 1,
            width: '100%',
            height: '100%',
            scrollingEnabled: true,
            bindingOptions: {
                formData: 'panel.formData',
                items: 'panel.items'
            },
            onInitialized: e => {
                section.form = e.component
                this.loadForm(section, data, this.$scope.popupType, null)
            }
        }
        if (section.form) {
            this.loadForm(section, data, this.$scope.popupType, null)
        }
    }

    trackChanges(section, index, value) {
        this.$scope.panels.forEach(panel => {
            if (panel != section) {
                if (panel.form) {
                    panel.formData[index] = value
                }
                if (panel.grid) {
                    panel.grid.option("dataSource").items().every(item => {
                        if (item.index == index) {
                            item.value = value
                        }
                        return true
                    })
                }
            }
        })
    }

    createGrid = () => {
        this.$scope.gridOptions = {
            type: GridTypes.PAGINATED_SMALL,
            idReferenceType: Enums.ReferenceType.IdTask,
            name: 'IssueCreateIssuesTasksGrid',
            columns: this.$scope.gridColumns,
            dataSource: new DataSource(this.$scope.gridData),
            onInitialized: e => {
                this.$scope.grid = e.component
                this.gridId = e.tableId
                this.createGridPromise.resolve()
            },
            editing: {
                mode: 'cell',
                allowAdding: false,
                allowUpdating: false,
                allowDeleting: false
            },
            masterDetail: {
                enabled: true,
                template: function (container, options) {
                    var error = options.data.error;
                    if (error) {
                        container.append($('<div ><p>' + error + '</p></div>'));
                    }
                    var warning = options.data.warning;
                    if (warning) {
                        container.append($('<div ><p>' + warning + '</p></div>'));
                    }
                },
                autoExpandAll: false
            },
            onRowPrepared: e => {
                if (e.rowType == "data") {
                    var row = $(e.rowElement)
                    if (!e.data.success && !e.data.error && !e.data.warning) {
                        e.isExpanded = false
                    }
                    if (e.data.success) {
                        row.css('background-color', '#02E6A1')
                        row.children('td').css('background-color', 'inherit')
                    } else if (e.data.error) {
                        e.isExpanded = true
                        row.css('background-color', '#F7484E')
                        row.children('td').css('background-color', 'inherit')
                    } else if (e.data.warning) {
                        e.isExpanded = true
                        row.css('background-color', '#FFA500')
                        row.children('td').css('background-color', 'inherit')
                    }
                }
            },
            addCustomFilters: false,
            buttonsOptions: {
                enabled: true
            }
        }

        if (this.$scope.grid) {
            this.$scope.grid.option('columns', this.$scope.gridColumns)
            this.$scope.grid.option('dataSource', this.$scope.gridData)
        }
    }

    updateGrid = (values) => {
        this.createGridPromise.then(() => {
            this.$scope.$broadcast(EventsNames.UPDATE_GRID_DATASOURCE + this.gridId, new DataSource(values))
        })
    }

    onPopoverValueIdSelected(valueId: number, datatypeId) {
        this.$scope.panels.forEach(panel => {
            if (panel.formData[datatypeId] !== undefined) {
                if (valueId)
                    angular.element('.data_type_id_' + datatypeId).find('.dx-invalid').removeClass('dx-invalid')
                panel.formData[datatypeId] = valueId
            }
        })
    }
}